import { isServerSide } from './server-side'

export function isPushNotificationSupported(): boolean {
  if (isServerSide()) {
    return false
  }

  if (typeof Notification === 'undefined') {
    return false
  }

  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window
}

export function isIosDevice(): boolean {
  if (isServerSide()) {
    return false
  }

  const IOS_DETECTION_REGEX = /iPad|iPhone|iPod/
  return IOS_DETECTION_REGEX.test(navigator.userAgent) && !(window as Any).MSStream
}

export function isAndroidDevice(): boolean {
  if (isServerSide()) {
    return false
  }

  const ANDROID_DETECTION_REGEX = /Android/i
  return ANDROID_DETECTION_REGEX.test(navigator.userAgent)
}

export function canInstallPwa(): boolean {
  if (isServerSide()) {
    return false
  }

  return (
    ('serviceWorker' in navigator && 'BeforeInstallPromptEvent' in window) || // Android Chrome
    isIosDevice() // iOS Safari
  )
}

export function isStandaloneMode(): boolean {
  if (isServerSide()) {
    return false
  }

  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as unknown as { standalone?: boolean }).standalone === true
  )
}
